import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import { useCurrentUserContext } from "providers";
import { UseLazyApiCallV2 } from "hooks";
import { message, Spin } from "antd";
import { InputField } from "./input-field";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const AddTemplate = ({
  onCloseTemplatePopup,
  refetchTemplates,
  setTemplateId,
  templateId,
  templatesData,
  current,
  category,
}) => {
  const { translator } = useLanguageTranslator();
  const reminderTrans = translator("caseDetail.reminder.form");
  const { user } = useCurrentUserContext();
  const [templateData, setTemplateData] = useState({
    title: "",
    subject: "",
    description: "",
  });
  const [
    addTemplate,
    {
      data: addTemplateData,
      isLoading: addTemplateLoading,
      error: addTemplateError,
    },
  ] = UseLazyApiCallV2({
    url: "/add_template",
    method: "POST",
  });

  const [
    updateTemplate,
    {
      data: updateTemplateData,
      isLoading: updateTemplateLoading,
      error: updateTemplateError,
    },
  ] = UseLazyApiCallV2({
    url: "/update_template",
    method: "POST",
  });

  function initialValuesForForm() {
    if (!templateId) {
      setTemplateData({});
    }

    if (templateId) {
      const selectedTemplate = templatesData?.templates?.find(
        (item) => item?.id == current,
      );
      const { title, subject, description } = selectedTemplate || {};
      setTemplateData({
        title,
        subject,
        description,
      });
    }
  }

  useEffect(() => {
    initialValuesForForm();
  }, [templateId, templatesData, category]);

  function onChangeInput(e) {
    const { name, value } = e.target;
    setTemplateData({
      ...templateData,
      [name]: value,
    });
  }
  function handleChangeTextEditor(content) {
    setTemplateData((prev) => ({ ...prev, description: content }));
  }
  async function addNewTemplate(e, template_id) {
    e.preventDefault();

    const { description, subject, title } = templateData;

    let params = {
      title,
      subject,
      description,
      createdBy: user?.email,
      category,
    };

    if (template_id) {
      params = { ...params, template_id };
    }
    const addOrUpdate = template_id ? updateTemplate : addTemplate;

    try {
      const res = await addOrUpdate({
        params,
      });
      if (res?.success) {
        message.success(res?.message);
        refetchTemplates();
        onCloseTemplatePopup();
        setTemplateData({});
        setTemplateId(null);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <Spin spinning={addTemplateLoading || updateTemplateLoading}>
      <div className={styles.addTemplate}>
        <form
          className={styles.form}
          onSubmit={(e) => addNewTemplate(e, templateId)}
        >
          <div className={styles.inputFields}>
            <InputField
              name={"title"}
              title={reminderTrans.templateTitle}
              placeholder={reminderTrans.templateTitle}
              value={templateData["title"]}
              type={"text"}
              onChangeInput={onChangeInput}
              required
            />
            <InputField
              name={"subject"}
              title={reminderTrans.subject}
              placeholder={reminderTrans.subject}
              value={templateData["subject"]}
              type={"text"}
              onChangeInput={onChangeInput}
            />
            <InputField
              name={"description"}
              title={reminderTrans.description}
              placeholder={reminderTrans.description}
              value={templateData["description"]}
              type={"text"}
              handleChangeTextEditor={handleChangeTextEditor}
              isQuill
              QuilHeight={`50dvh`}
            />
          </div>
          <div className={styles.downloadBtnContainer}>
            <button
              type="button"
              onClick={onCloseTemplatePopup}
              style={{
                backgroundColor: "white",
              }}
            >
              <span style={{ color: "#cd2a3f" }}>{translator("cancel")}</span>
            </button>
            <button type="submit">
              <span>
                {templateId ? translator("update") : translator("save")}
              </span>
            </button>
          </div>
        </form>
      </div>
    </Spin>
  );
};
